<template>
  <div>
    <div class="ma-auto question-order">
      <dnd-zone 
        v-if="arr.length"
        :transition-duration="0.3"
        >
        <dnd-container
          :dnd-model="arr"
          dnd-id="grid-example"
          class="row dnd-container"
          dense
        >
          <dnd-item
            v-for="(item, key) in arr"
            :key="item.id"
            :dnd-id="key"
            :dnd-model="item"
            class="dnd-item"
          >
          
            <div class="d-flex question-order-col p-x-2 m-y-2 p-y">
              <div class="question-item__wrapper">

                <div class="flex fd-column h-10">
                  <div class="question__title flex ai-center p-x-3 p-y-3 jc-start ta-left" 
                    v-if="item['title']"
                    style="min-height: 60px;">
                    <span v-html="$options.filters.mathformat(item['title'])"></span>
                  </div>
                  <div>
                    <v-img :src="item['img']" height="200px" v-if="item['img']"/>
                  </div>
                </div>
              </div>
            </div>
          </dnd-item>
        </dnd-container>
      </dnd-zone>
    
      <div class="ta-center m-t-10 btn-content">
        <v-btn :loading="loading" @click="answer" class="mt-8" large color="info">
          Ответить на вопрос
        </v-btn>
      </div>
    </div>


  </div>
</template>
<script>


export default {
  components: {},
  props: {
    data: Object,
  },
  computed:{},
  async mounted() {
    this.prevArr = await JSON.parse(JSON.stringify(this.data["answers"]));
    this.question = await JSON.parse(JSON.stringify(this.data));

    this.arr = await JSON.parse(JSON.stringify(this.data["answers"])).sort(() => Math.random() - 0.5);
    this.prevArr = this.arr;
    console.log(this.arr, 'this.arr')
  },
  data() {
    return {
      arr: [],
      prevArr: [],
      question: [],
      loading: false,
    };
  },
  methods: {
    answer() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500);
    },
    play(item, arrItems) {
      let audio = item.audio_document
      arrItems.forEach((el)=>{
        if(el.track)
          el.track.pause()
        el.audio_document.play = false
      })
      audio.play = true;
      item.track = new Audio(audio.file);
      
      item.track.play();
      console.log(document.querySelectorAll("audio"))
      item.track.onended = function () {
        audio.play = false;
      };
    },
    pause(item) {
      let audio = item.audio_document
      audio.play = false;
      item.track.pause();
    },
  },
};
</script>
